import React, { useEffect, useState } from "react";
import { Card, Col, Container, Form, ListGroup, Row, Spinner, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import { studyMedicalReviewServices } from "../../../../APIServices/studyMedicalReviewServices";
import Swal from "sweetalert2";
import { BsBuildingsFill, BsCheck2All, BsClock, BsEye, BsFileText } from "react-icons/bs";
import { PiWarning } from "react-icons/pi";
import ReviewStatusDistribution from "./ReviewStatusDistribution";
import CompletionbyForm from "./CompletionbyForm";
import ReviewerPerformance from "./ReviewerPerformance";
import { CiSearch } from "react-icons/ci";
import UseToggle from "../../../../Hooks/UseToggle";
import MediaclReviewAction from "./MediaclReviewAction";
import FilterMedicalTask from "./FilterMedicalTask";

const MedicalBulkReview = ({ onMouseDown, tableRef, handleAddNewTab }) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedSiteIds, setSelectedSiteIds] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [eventId, setEventId] = useState("");
  const [timePointId, setTimePointId] = useState("");
  const [formId, setFormId] = useState("");
  const [taskList, setTaskList] = useState([]);
  const [loading, setLoading] = useState(false);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [searchData, setSearchData] = useState("");
  const toggles = UseToggle();
  const studyPermission = JSON.parse(localStorage.getItem("studyPermissionData"));
  const dataType = (StudyMode === "Live Mode" || StudyMode === "QC Mode") ? ((studyPermission?.liveSummeryMedicalReview || studyPermission?.qcSummeryMedicalReview) ? "ALLBULK" : "MYBULK") : (StudyMode === "SDV Live Mode" || StudyMode === "SDV QC Mode") ? ((studyPermission?.liveSDVSummeryMedicalReview || studyPermission?.qcSDVSummeryMedicalReview) ? "ALLBULK" : "MYBULK") : "MYBULK"

  const getSubjectMedicalReviewTask = async () => {
    setLoading(true);
    let data = await studyMedicalReviewServices.getSubjectMedicalReviewTask(
      studyId,
      "edc",
      "pending",
      "ALL",
      dataType,
      StudyMode,
      siteId,
      subjectId,
      formId,
      eventId,
      timePointId,
    );
    setTaskList(data?.data || []);
    setLoading(false);
  };

  const isOverdue = (dateString) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const givenDate = new Date(dateString);
    givenDate.setHours(0, 0, 0, 0);

    return givenDate < today ? "Yes" : "No";
  };

  useEffect(() => {
    getSubjectMedicalReviewTask();
  }, [studyId, dataType]);

  const handleSelect = (row) => {
    const { _id, siteId } = row;

    if (selectedIds.includes(_id)) {
      setSelectedIds((prev) => prev.filter((id) => id !== _id));
      setSelectedSiteIds((prev) => prev.filter((id) => id !== siteId));
    } else {
      setSelectedIds((prev) => [...prev, _id]);
      setSelectedSiteIds((prev) => [...new Set([...prev, siteId])]);
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(taskList.map((item) => item._id));

      setSelectedSiteIds([
        ...new Set(taskList.map((item) => item.siteId)),
      ]);
    } else {
      setSelectedIds([]);
      setSelectedSiteIds([]);
    }
  };

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          <i className="fa slid fa-filter" onClick={() => toggles.setToggle()}></i>
        </div>
        <button disabled={selectedIds?.length === 0} onClick={() => toggles?.setToggle1()} className={`updateProfile`}>
          Review
        </button>
      </div>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
      >
        {loading ? (
          <PageLoader />
        ) : taskList?.length === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG={"Task list not found!."} />
          </div>
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    className="text-center"
                    style={{ width: 45 }}
                  >
                    <Form.Check
                      checked={
                        taskList?.length > 0 &&
                        selectedIds.length === taskList.length
                      }
                      onChange={handleSelectAll}
                    />
                  </th>

                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Site Id</th>

                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Subject Id</th>

                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Event Id</th>

                  <th onMouseDown={(e) => onMouseDown(e, 4)}>Form Name</th>

                  <th onMouseDown={(e) => onMouseDown(e, 5)}>Form Version</th>

                  <th onMouseDown={(e) => onMouseDown(e, 6)}>Due Date</th>

                  <th onMouseDown={(e) => onMouseDown(e, 7)}>Overdue</th>

                  <th onMouseDown={(e) => onMouseDown(e, 8)}>Assigned To</th>
                </tr>
              </thead>

              <tbody>
                {taskList?.map((metadata, index) => (
                  <tr key={index}>
                    <td className="text-center">
                      <Form.Check
                        checked={selectedIds.includes(metadata._id)}
                        onChange={() => handleSelect(metadata)}
                      />
                    </td>

                    <td>{metadata?.siteName}</td>

                    <td>{metadata?.subjectName}</td>

                    <td>
                      {metadata?.eventName}{" "}
                      {metadata?.timePointName
                        ? `(${metadata?.timePointName})`
                        : ""}
                    </td>

                    <td>{metadata?.formName}</td>

                    <td>{metadata?.version}</td>

                    <td>{metadata?.dueDate}</td>

                    <td
                      className={`fw-bold ${isOverdue(metadata?.dueDate) === "Yes" ? "text-danger" : "text-success"}`}
                    >
                      {isOverdue(metadata?.dueDate)}
                    </td>

                    <td>{metadata?.assignedTo}</td>
                    
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </SplitPane>
      <MediaclReviewAction
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        Title="Review Action"
        studyId={studyId}
        StudyMode={StudyMode}
        selectedIds={selectedIds}
        selectedSiteIds={selectedSiteIds}
        getSubjectMedicalReviewTask={getSubjectMedicalReviewTask}
      />
      <FilterMedicalTask
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title={"Filter"}
        siteId={siteId}
        setSiteId={setSiteId}
        subjectId={subjectId}
        setSubjectId={setSubjectId}
        eventId={eventId}
        setEventId={setEventId}
        timePointId={timePointId}
        setTimePointId={setTimePointId}
        loading={loading}
        formId={formId}
        setFormId={setFormId}
        getSubjectMedicalReviewTask={getSubjectMedicalReviewTask}
      />
    </>
  );
};

export default MedicalBulkReview;
